import { CREATE_ABC, CREATE_ABC_MANUAL, DELETE_ABC, EDIT_ABC, GET_ABC_BY_ID, GET_ABCS } from './abc.types';

/** Abcs */

export const getAbcs = (params, clientId, load) => {
    return {
        type: GET_ABCS,
        payload: { params, clientId, load },
    };
};
export const getAbcById = (abcId) => {
    return {
        type: GET_ABC_BY_ID,
        payload: { abcId },
    };
};

export const createAbcManual = (body, clientId, reqParams) => {
    return {
        type: CREATE_ABC_MANUAL,
        payload: { body, clientId, reqParams },
    };
};

export const createAbc = (body) => {
    return {
        type: CREATE_ABC,
        payload: { body },
    };
};

export const editAbc = (id, body, clientId, reqParams) => {
    return {
        type: EDIT_ABC,
        payload: { id, body, clientId, reqParams },
    };
};

export const deleteAbc = (id, clientId, reqParams) => {
    return {
        type: DELETE_ABC,
        payload: { id, clientId, reqParams },
    };
};

/** End */
